export default "__VITE_ASSET__D9nh3iKi__"